import React, { Component } from "react";
import Registry from "../../../Utils/Registry";

import EnterprisePaymentsItem from "./PaymentItem";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import Variables from "../../../Utils/Variables";
import { StripeProvider, Elements } from "react-stripe-elements";
import EnterprisePaymentsBaseForm from "../Payments/BaseForm";
import {NotificationManager} from "react-notifications";



class EnterprisePaymentsList extends Component{
    constructor(props){
        super(props);

        this.loadData = this.loadData.bind(this);
        this.onCardRemoved = this.onCardRemoved.bind(this);
        this.togglePaymentModal = this.togglePaymentModal.bind(this);
        this.onNewPaymentMethod = this.onNewPaymentMethod.bind(this);

        this.api = Registry.registered("api");

        this.paymentsList = null;

        this.state = {
            cards: [],
            loading: false,
            add_payment_shown: false
        };
    }

    componentDidMount(){
        this.loadData();
    }

    loadData(){
        this.setState({loading: true, cards: []});
        this.api.get("/business/paymentMethods")
            .then(results => {
                let listing = [];
                if(results && results.hasOwnProperty("data"))
                    listing = results.data;
                this.setState({cards:listing, loading: false});
            });
    }

    onCardRemoved(card){
        NotificationManager.success("Carte supprimée");
        this.loadData();
    }

    togglePaymentModal(){
        this.setState({add_payment_shown: !this.state.add_payment_shown});
    }

    onNewPaymentMethod(){
        if(this.paymentsList)
            this.paymentsList.loadData();
        setTimeout(this.togglePaymentModal, 1000);
        this.loadData();
    }

    render(){
        return (
            <div>
                <div className="d-flex justify-content-between pad-b-10">
                    <h2 className="ty-subtitle">Vos moyens de paiement</h2>

                    <div>
                        <Button color="primary" className="text-uppercase btn-xs" onClick={this.togglePaymentModal}>
                            <i className="icon icon-plus marg-r-10"> </i> Ajouter
                        </Button>
                    </div>
                </div>

                <div className="ty-block">
                    {
                        this.state.loading ?
                            <div className="center">
                                <i className="icon icon-loading animated spin infinite f-20"> </i>
                            </div>
                            :
                            (
                                this.state.cards.length === 0 ? "Aucun moyen de paiment ajouté"
                                    :
                                    this.state.cards.map((card, i) => {
                                        if(card.object === "card")
                                            return <EnterprisePaymentsItem key={i} card={card} onCardRemove={this.onCardRemoved} />;
                                        else
                                            return <EnterprisePaymentsItem key={i} sepa={card} onCardRemove={this.onCardRemoved} />;
                                    })
                            )
                    }
                </div>

                <Modal isOpen={this.state.add_payment_shown} toggle={this.togglePaymentModal}>
                    <ModalHeader toggle={this.togglePaymentModal}>Ajouter un moyen de paiement</ModalHeader>
                    <ModalBody>
                        <StripeProvider apiKey={Variables.stripe_token}>
                            <Elements locale={(window.navigator.userLanguage || window.navigator.language)}>
                                <EnterprisePaymentsBaseForm hideForm={this.togglePaymentModal} newPaymentMethodAdded={this.onNewPaymentMethod} showTitle={false} tyBlock={false} />
                            </Elements>
                        </StripeProvider>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

EnterprisePaymentsList.defaultProps = {

};

export default EnterprisePaymentsList;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Payments/List.js